module.exports = __webpack_public_path__ + "static/media/gear.e2b55183.svg";